import "./App.css";
import { NewHomePage } from "./newModel/newHomePage";

function App() {
  return (
    <div>
      <NewHomePage />
    </div>
  );
}

export default App;
